export default function isFunction(test) {
    return typeof test === 'function';
}
//# sourceMappingURL=isFunction.js.map